export const LOCALES = ["pt-BR", "en-US", "es-ES"] as const;

export type SupportedLocale = typeof LOCALES[number];

export const DEFAULT_LOCALE: SupportedLocale = "pt-BR";

export const LOCALE_STORAGE_KEY = "gamefik.manage.locale";

export const LANGUAGE_LABELS: Record<SupportedLocale, string> = {
  "pt-BR": "Português",
  "en-US": "English",
  "es-ES": "Español",
};

export const DAYJS_LOCALE_BY_APP_LOCALE: Record<SupportedLocale, string> = {
  "pt-BR": "pt-br",
  "en-US": "en",
  "es-ES": "es",
};
